import { MarkChatReadOutlined } from "@mui/icons-material";
import { memo, useEffect, useState } from "react";
import api from "../../../api/api";
import styles from "./SnapppayPayments.module.css";
import DataTable from "../../../Components/DataTable/DataTable";
import { toJalaali } from "jalaali-js";
import { CheckSquareOutlined, CloseSquareOutlined } from "@ant-design/icons";
import { Button, notification, Popconfirm, message } from "antd";
import ConvertNumbersToEn from "../../../Util/ConvertNumbersToEn";

const SnapppayPayments = () => {
  const [items, setItems] = useState([]);
  const [notificationApi, contextHolder] = notification.useNotification();
  const [pagination, setPagination] = useState({});

  const filtersBeautify = (fData = {}) => {
    const filters = {
      ...(fData.status?.at(0) ? { status: fData.status.at(0) } : {}),
      ...(fData.id?.at(0) ? { id: fData.id.at(0) } : {}),
      ...(fData.firstname?.at(0) ? { firstname: fData.firstname.at(0) } : {}),
      ...(fData.lastname?.at(0) ? { lastname: fData.lastname.at(0) } : {}),
      ...(typeof fData.verified?.at(0) !== "undefined"
        ? {
            verified:
              fData.verified.at(0) === "true" || fData.verified.at(0) === true,
          }
        : {}),
      ...(typeof fData.canceled?.at(0) !== "undefined"
        ? {
            canceled:
              fData.canceled.at(0) === "true" || fData.canceled.at(0) === true,
          }
        : {}),
      ...(fData.mobile?.at(0)
        ? { mobile: ConvertNumbersToEn(fData.mobile.at(0)) }
        : {}),
      ...(fData.fromDate?.at(0) ? { fromDate: fData.fromDate.at(0) } : {}),
      ...(fData.toDate?.at(0) ? { toDate: fData.toDate.at(0) } : {}),
      // map table column key `transaction_id` to API param `transactionId`
      ...(fData["transaction_id"]?.at(0)
        ? { transactionId: fData["transaction_id"].at(0) }
        : {}),
      ...(fData.transactionId?.at(0)
        ? { transactionId: fData.transactionId.at(0) }
        : {}),
      ...(fData.token?.at(0) ? { token: fData.token.at(0) } : {}),
    };

    return filters;
  };
  const columns = [
    {
      title: "شناسه",
      dataIndex: "id",
      width: 90,
      searchable: true,
    },
    {
      title: "مبلغ",
      dataIndex: "amount",
      width: 90,
    },
    { title: "موبایل", dataIndex: "mobile", width: 130, searchable: true },
    { title: "نام", dataIndex: "firstname", width: 90, searchable: true },
    {
      title: "نام خانوادگی",
      dataIndex: "lastname",
      width: 140,
      searchable: true,
    },
    {
      title: "توکن",
      dataIndex: "token",
      width: 260,
      className: styles.ltr,
      searchable: true,
      render: (token) => {
        return (
          <span
            onClick={() => {
              navigator.clipboard.writeText(token);
              message.success("توکن در کلیپ بورد کپی شد");
            }}
          >
            {token}
          </span>
        );
      },
    },
    {
      title: "شناسه تراکنش",
      dataIndex: "transaction_id",
      width: 160,
      className: styles.ltr,
      searchable: true,
      render: (token) => {
        return (
          <span
            onClick={() => {
              navigator.clipboard.writeText(token);
              message.success("شناسه تراکنش در کلیپ بورد کپی شد");
            }}
          >
            {token}
          </span>
        );
      },
    },
    {
      title: "تایید شده",
      dataIndex: "verified",
      width: 110,
      align: "center",
      filterMultiple: false,
      filters: [
        { text: "تایید شده", value: "true" },
        { text: "تایید نشده", value: "false" },
      ],
      render: (text, record) => {
        return text ? (
          <CheckSquareOutlined style={{ fontSize: "30px", color: "green" }} />
        ) : (
          <CloseSquareOutlined style={{ fontSize: "30px", color: "red" }} />
        );
      },
    },
    {
      title: "وضعیت",
      dataIndex: "status",
      width: 120,
      filterMultiple: false,
      filters: [
        { text: "در حال پرداخت", value: "init" },
        { text: "پرداخت شده", value: "paid" },
        { text: "پرداخت نشده", value: "failed" },
        { text: "لغو شده", value: "canceled" },
      ],
      render: (text, record) => {
        switch (text) {
          case "init":
            return "در حال پرداخت";
          case "paid":
            return "پرداخت شده";
          case "failed":
            return "پرداخت نشده";
          case "canceled":
            return "لغو شده";
          default:
            return text;
        }
      },
    },
    {
      title: "زمان ایجاد",
      dataIndex: "created_at",
      width: 170,
      render: (text, record) => {
        if (text && text !== "-") {
          const date = new Date(text);
          const jalali = toJalaali(
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate()
          );
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
              {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        }
      },
    },
    {
      title: "زمان چک",
      dataIndex: "checked_at",
      width: 160,
      render: (text, record) => {
        if (text && text !== "-") {
          const date = new Date(text);
          const jalali = toJalaali(
            date.getFullYear(),
            date.getMonth() + 1,
            date.getDate()
          );
          return (
            <span dir="ltr">
              {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
              {date.toLocaleTimeString("eo", { hour12: false })}
            </span>
          );
        }
      },
    },
    {
      title: "لغو پرداخت",
      key: "canceled",
      width: 130,
      filterMultiple: false,
      filters: [
        { text: "لغو شده", value: "true" },
        { text: "لغو نشده", value: "false" },
      ],
      render: (text, record) => {
        return (
          record.verified && (
            <Popconfirm
              title="آیا از حذف پرداخت مطمئن هستید؟"
              onConfirm={() => cancelPayment(record)}
            >
              <Button danger htmlType="button">
                لغو پرداخت
              </Button>
            </Popconfirm>
          )
        );
      },
    },
  ];

  useEffect(() => {
    loadItems();
  }, []);

  const loadItems = (page = 1, pageSize = 100, filters = {}) => {
    console.log({ filters });
    api
      .get("/payment/snapp-pay/report", {
        params: { page, pageSize, ...filters },
      })
      .then((res) => {
        const data = res.data;
        setItems(data.items);
        setPagination(res.data.pagination);
      });
  };

  const cancelPayment = (record) => {
    const data = {
      token: record.token,
      transactionId: record.transaction_id,
    };

    api
      .post("/payment/snapp-pay/cancel", data)
      .then((res) => {
        if (res.data?.status === "success") {
          const newItems = [...items];
          newItems.forEach((item, index) => {
            if (item.id === record.id) {
              item.verified = false;
            }
          });
          setItems(newItems);

          notificationApi.open({
            message: "لغو با موفقیت انجام شد.",
            duration: 5,
            type: "success",
            placement: "top",
            className: styles.rtl,
          });
        } else {
          notificationApi.open({
            message: res.data?.message,
            duration: 5,
            type: "error",
            placement: "top",
            className: styles.rtl,
          });
        }
      })
      .catch((error) => {
        notificationApi.open({
          message: error.message,
          duration: 5,
          type: "error",
          placement: "top",
          className: styles.rtl,
        });
      });
  };

  return (
    <>
      {contextHolder}
      <DataTable
        tableKey="snapppay-payments"
        id="SnapppayPayments"
        dynamicPagination
        recordsCount={pagination.total}
        filtersBeautify={filtersBeautify}
        // recordsCount={totalCount}

        dataSource={items}
        setDataSource={setItems}
        columns={columns}
        // permissionsPrefix="flags"
        reload={loadItems}
        recordCreatorDisabled
        header={{
          title: "پرداخت های اسنپ پی",
          avatar: { icon: <MarkChatReadOutlined />, size: "large" },
        }}
      />
    </>
  );
};

export default memo(SnapppayPayments);
